import type { Mail } from 'modules/Mails/hooks';
import { createContext, useContext } from 'react';

type ThreadMessageContextValue = {
  mail: Mail;
  isOutbound: boolean;
  senderName: string;
  dateLabel: string;
  onCollapse: () => void;
};

const ThreadMessageContext = createContext<ThreadMessageContextValue | null>(null);

export const ThreadMessageProvider = ThreadMessageContext.Provider;

export const useThreadMessage = (): ThreadMessageContextValue => {
  const context = useContext(ThreadMessageContext);
  if (context === null)
    throw new Error('useThreadMessage must be used within a ThreadMessageProvider');
  return context;
};
